export default __webpack_public_path__ + "static/media/sahasra_seva_samithi.6bfefdf2.png";